var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M0 10.296V20.73h20.49V10.04h-.014C20.34 4.474 15.816 0 10.245 0 4.673 0 .15 4.473.013 10.04H0v.256z",
    transform: "translate(.242 .681)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M0 10.297C0 4.61 4.586 0 10.245 0c5.658 0 10.244 4.61 10.244 10.297H0z",
    transform: "translate(.242 .681)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M18.12 9.772c0 4.371-3.526 7.915-7.875 7.915-4.35 0-7.875-3.544-7.875-7.915h15.75z",
    transform: "translate(.242 .681)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M7.452 14.397c.485 1.064 1.552 1.805 2.792 1.805 1.241 0 2.308-.741 2.793-1.805H7.452z",
    transform: "translate(.242 .681)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.0d7f63222f5393a8dd997e3b3a4786f7.svg";
export { ForwardRef as ReactComponent };